import { extendValidations } from '@atoms/form-elements';
import { GERMANY_ID, NETHERLANDS_ID } from '@constants/countries';
import { SelectedCountry, useTranslate } from '@utilities/hooks';

export const useCountryPostcodeValidator = (selectedCountry: SelectedCountry) => {
    const { id: selectedCountryId } = selectedCountry;

    const countryValidator = (value: string) => {
        if (!value) return;

        let isValid;

        switch (selectedCountryId) {
            case NETHERLANDS_ID: {
                isValid = /^[1-9][0-9]{3} ?[a-z]{2}$/i.test(value);
                break;
            }
            case GERMANY_ID: {
                isValid = /\b(?!01000)(?!99999)(0[1-9]\d{3}|[1-9]\d{4})\b$/.test(value);
                break;
            }
            default: {
                isValid = true;
                break;
            }
        }

        return isValid ? undefined : useTranslate('EnterValidPostCode');
    };

    extendValidations({ zipCode: countryValidator });
};
